import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Component to handle cards subdomain root redirect
 * Redirects cards.company.com to /operations by default
 */
const CardsRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to default card (operations)
    navigate("/operations", { replace: true });
  }, [navigate]);

  return null;
};

export default CardsRedirect;
